var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("div", { staticClass: "header" }, [
        _c("h1", [_vm._v("AI Documents")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              "margin-left": "auto",
              display: "flex",
              gap: "8px",
              "align-items": "center"
            }
          },
          [
            _c(
              "button",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    return _vm.openModal("search")
                  }
                }
              },
              [_vm._v("Ask (Dialog)")]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("AskModal", { ref: "askModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }